import React from 'react';
import { Card } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.css';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { Person, Menu, Favorite, Money, Theaters } from '@material-ui/icons';
import DashboardLineChart from '../../components/Chart/DashboardLineChart';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';
import { compose } from 'redux';
import { Route, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import d1 from '../../assets/images/icon/d1.png';
import d2 from '../../assets/images/icon/d2.png';
import d3 from '../../assets/images/icon/d3.png';
import BookingList from '../../components/Providers/BookingList';
import { NotificationManager } from 'react-notifications';

const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
const styles = theme => ({
    heading: {
        color: '#ffffff'
    },
    paper: {
        backgroundColor: theme.palette.primary.main
    },
    card: {
        color: theme.palette.secondary.main
    }
});
let isLoading = true;
class ProviderDashboard extends React.Component {
    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            menuState: false,
            providerData: '',
            weeklyData: [],
            monthlyData: [],
            yearlyData: [],
            loader: true
        };
    }
    componentDidMount() {
        this.getDashboardData();
        // this.updateProvider = setInterval(() => this.getDashboardData(), 15000)
        this.updateProvider = setInterval(() =>
            console.log("modified web 2")
            //  this.getDashboardData()
            , 15000)
    }

    /* componentWillUnmount() {
        clearInterval(this.updateProvider)
    } */

    getDashboardData = () => {
        this.props.providerDashboardDataAction(
            { type: 1, datetime: new Date() },
            this.onWeeklyDone
        );
        this.props.providerCheckAction(this.onCheckDone);
    };

    onCheckDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            this.setState({ providerData: data.data.detail });
        }
    };

    onWeeklyDone = (success, data) => {
        if (success) {
            this.setState({ weeklyData: data.data[0].data }, () => {
                this.props.providerDashboardDataAction(
                    { type: 2, datetime: new Date() },
                    this.onMonthlyDone
                );
            });
        }
    };
    onMonthlyDone = (success, data) => {
        if (success) {
            this.setState({ monthlyData: data.data[0].data }, () => {
                this.props.providerDashboardDataAction(
                    { type: 3, datetime: new Date() },
                    this.onYearlyDone
                );
            });
        }
    };
    onYearlyDone = (success, data) => {
        if (success) {
            this.setState({ yearlyData: data.data[0].data, loader: false });
        }
    };

    onOptionMenuSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose = () => {
        this.setState({ menuState: false });
    };

    render() {
        const { classes } = this.props;
        const {
            providerData,
            weeklyData,
            monthlyData,
            yearlyData
        } = this.state;
        return (
            <div className="tz-2-com tz-2-main">
                <h4>
                    <FormattedMessage
                        id="providerDashboard"
                        defaultMessage="Provider Dashboard"
                    />
                </h4>
                {/* <h3>ProviderDashboard.jsx</h3> */}
                <p style={{ padding: 10 }}>
                    <b>Note:</b> Your profile will not be listed until you have
                    atleast one address, one service to book and email/phone
                    number should be verified.
                </p>

                <div className="tz-2-main-com">
                    <div className="tz-2-main-1" onClick={() => {
                        this.props.history.push({
                            pathname: `/provider/booking/`,
                            state: { type: 1, append: false }
                        });
                    }}>
                        <div className="tz-2-main-2" style={{ backgroundColor: "#0078FF", marginRight: 15, borderRadius: 15, cursor: "pointer" }}>
                            {' '}
                            {/* <img src={d1} alt="Initiated Bookings" /> */}
                            <h2 style={{ "color": "#FFFFFF" }}>
                                {' '}
                                {providerData &&
                                    providerData.initiated_booking_count}
                            </h2>{' '}
                            <p className="provide_sp" style={{ "color": "#FFFFFF" }}>
                                Requested
                            </p>
                            {/* <p>Total no of Bookings</p> */}
                        </div>
                    </div>
                    <div className="tz-2-main-1" onClick={() => {
                        this.props.history.push({
                            pathname: `/provider/booking/`,
                            state: { type: 2, append: false }
                        });
                    }}>
                        <div className="tz-2-main-2" style={{ backgroundColor: "#0078FF", marginRight: 15, borderRadius: 15, cursor: "pointer" }}>
                            {' '}
                            <h2 style={{ "color": "#FFFFFF" }}>
                                {' '}
                                {providerData &&
                                    providerData.inprogress_booking_count}
                            </h2>{' '}
                            <p className="provide_sp" style={{ "color": "#FFFFFF" }}>
                                Confirmed
                            </p>
                        </div>
                    </div>
                    <div className="tz-2-main-1" onClick={() => {
                        this.props.history.push({
                            pathname: `/provider/booking/`,
                            state: { type: 3, append: false }
                        });
                    }}>
                        <div className="tz-2-main-2" style={{ backgroundColor: "#0078FF", marginRight: 15, borderRadius: 15, cursor: "pointer" }}>
                            {' '}
                            <h2 style={{ "color": "#FFFFFF" }}>
                                {providerData &&
                                    providerData.completed_booking_count}
                            </h2>{' '}
                            <p className="provide_sp" style={{ "color": "#FFFFFF" }}>
                                Completed
                            </p>
                        </div>
                    </div>
                </div>
                <div className="db-list-com tz-db-table">
                    <div className="row">
                        <div className="col-md-12 ds-boar-title">
                            <h2>
                                <FormattedMessage
                                    id="booking.heading"
                                    defaultMessage="Bookings"
                                />
                            </h2>
                        </div>
                        <HOCSectionLoader loading={this.state.loader}>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="weeklyBookings"
                                        defaultMessage="Weekly Bookings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={weeklyData}
                                    {...this.props}
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="monthlyBookings"
                                        defaultMessage="Monthly Bookings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={monthlyData}
                                    {...this.props}
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="yearlyBookings"
                                        defaultMessage="Yearly Bookings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={yearlyData}
                                    {...this.props}
                                />
                            </div>
                        </HOCSectionLoader>
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    withTheme(),
    connect(
        null,
        actions
    )
);

export default withRouter(composedComponent(ProviderDashboard));



// WEBPACK FOOTER //
// ./src/views/User/ProviderDashboard.jsx